import React from "react";

import { FormHelperText } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import { Checkbox } from "formik-material-ui";

const ResignNauticalRedText = ({ disableAll }) => {
  const { errors, touched } = useFormikContext();

  return (
    <div>
      <p className="underline text-base font-bold">
        AITHΣΗ ΕΠΑΝΑΠΟΓΡΑΦΗΣ ΚΟΚΚΙΝΟ (Π.Δ. 260/2001)
      </p>
      <br></br>
      <p className="text-base font-bold">
        Σας υποβάλλω σχετικά δικαιολογητικά και παρακαλώ όπως προβείτε στην
        επαναπογραφή ναυτικού φυλλαδίου. Με ατομική μου ευθύνη και γνωρίζοντας
        τις κυρώσεις, που προβλέπονται από τις διατάξεις της παρ. 6 του άρθρου
        22 του Ν. 1599/1986, σας δηλώνω υπεύθυνα ότι:
      </p>
      <br></br>
      <p className="text-base font-bold">
        Δεν έχω καταδικαστεί αμετάκλητα για λιποταξία ή ανυποταξία.
      </p>
      <br></br>
      <p className="text-base font-bold">
        Δεν έχω την ιδιότητα του εν ενεργεία ή συνταξιούχου πολιτικού ή
        στρατιωτικού δημοσίου υπαλλήλου, υπαλλήλου νομικού προσώπου δημοσίου
        δικαίου ή κοινωνικοποιημένου οργανισμού και δεν είμαι συνταξιούχος ως
        άνω φορέων (π.δ. 260/2001, όπως ισχύει).
      </p>
      <br></br>
      <div className="flex flex-col pt-5">
        {errors["read_dilosi_idiotiton"] &&
          touched["read_dilosi_idiotiton"] && (
            <FormHelperText className="text-xl text-error border-l-2 border-error pl-1">
              {errors["read_dilosi_idiotiton"]}
            </FormHelperText>
          )}
        <div className="flex items-center">
          <p className="text-lg font-bold">
            Έχω διαβάσει και δηλώνω υπεύθυνα τα παραπάνω
          </p>

          <Field
            component={Checkbox}
            type="checkbox"
            name="read_dilosi_idiotiton"
            disabled={disableAll}
          />
        </div>
      </div>
    </div>
  );
};

export default ResignNauticalRedText;
